export default "__VITE_ASSET__c49f5ed5__"